var ApplicationSearchService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AflaModuleStrategyService } from "../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { OdataQueryService } from "../../shared/services/odata-query/odata-query.service";
import { UtcDatePipe } from "../../shared/pipes/utc-date/utc-date.pipe";
import { ApiUserConstants } from "../../shared/constants/api-constants/api-user.constants";
let ApplicationSearchService = class ApplicationSearchService {
    static { ApplicationSearchService_1 = this; }
    httpClient;
    oDataQueryService;
    utcDate;
    moduleUsers;
    constructor(httpClient, oDataQueryService, utcDate) {
        this.httpClient = httpClient;
        this.oDataQueryService = oDataQueryService;
        this.utcDate = utcDate;
    }
    // private static buildSimpleSearchRequest
    // (text: string,
    //  searchColumn: string | typeof SharedConstants.SEARCH_BY_DEFAULT,
    //  aflaModuleStrategyService: AflaModuleStrategyService,
    //  moduleID: number)
    //   : Observable<IOdataCollection<IApplicationEntity>> {
    //   return aflaModuleStrategyService.buildApplicationSearchBaseRequest(moduleID);
    // }
    //
    static buildGetSingleRequest(aflaModuleStrategyService, jobId, expandList) {
        const params = {
            $expand: expandList,
            $filter: AflaModuleStrategyService.buildJobIDFilter(jobId)
        };
        return aflaModuleStrategyService.getApplicationsQuery(params);
    }
    static getExpandList(aflaModuleStrategyService) {
        return aflaModuleStrategyService.expandListForApplicationPartial;
    }
    getSingleApplication(aflaModuleStrategyService, jobId) {
        return ApplicationSearchService_1.buildGetSingleRequest(aflaModuleStrategyService, jobId, ApplicationSearchService_1.getExpandList(aflaModuleStrategyService))
            .pipe(map((applicationList) => {
            return applicationList.value.map((application) => {
                return application;
                // return aflaModuleStrategyService.mapFromApplicationEntityToApplicationSearchModel(application);
            })?.pop();
        }));
    }
    sortApplicationList(applications, sortColumn, ascendingSort = true) {
        let column;
        if (applications.length > 0) {
            // use the first column unless another column has been specified - make sure that the specified column has been included in the list
            // tslint:disable-next-line:forin
            for (const aKey in applications[0]) {
                if (!column) {
                    column = aKey;
                    if (!sortColumn)
                        break;
                }
                if (aKey === sortColumn) {
                    column = aKey;
                    break;
                }
            }
            if (ascendingSort) {
                return applications.sort((a, b) => {
                    if (Date.parse(a[column]))
                        return 0 - (a[column] > b[column] ? -1 : 1);
                    if (typeof (a[column]) === "string")
                        return 0 - (a[column].toLowerCase() > b[column].toLowerCase() ? -1 : 1);
                    else if (typeof (a[column]) === "number")
                        return 0 - (a[column] > b[column] ? -1 : 1);
                    else
                        return 0 - (a[column] > b[column] ? -1 : 1);
                });
            }
            else {
                return applications.sort((a, b) => {
                    if (Date.parse(a[column]))
                        return 0 - (a[column] > b[column] ? 1 : -1);
                    if (typeof (a[column]) === "string")
                        return 0 - (a[column].toLowerCase() > b[column].toLowerCase() ? 1 : -1);
                    else if (typeof (a[column]) === "number")
                        return 0 - (a[column] > b[column] ? 1 : -1);
                    else
                        return 0 - (a[column] > b[column] ? 1 : -1);
                });
            }
        }
        else {
            return applications;
        }
    }
    getUserName(userId) {
        return this.httpClient
            .get(`${ApiUserConstants.URL}/${userId}`);
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: OdataQueryService },
        { type: UtcDatePipe }
    ];
};
ApplicationSearchService = ApplicationSearchService_1 = __decorate([
    Injectable({
        providedIn: "root"
    })
], ApplicationSearchService);
export { ApplicationSearchService };
